import React from "react";
import AppPriorities from "./AppPriorities";
import DualFuel from "./DualFuel";
import Thresholds from "./Thresholds";

const RuleEngine = () => (
	<div className="right_col settings-page" role="main">
		<header className="page-heading">
			<div>
				<p className="eyebrow">ENERGY AUTOMATION</p>
				<h1>Smart rules</h1>
				<p>Configure appliance priorities, operating thresholds and dual-fuel behaviour.</p>
			</div>
		</header>

		<section className="x_panel" aria-labelledby="priorities-title">
			<div className="x_title">
				<h2 id="priorities-title">Appliance priorities</h2>
				<div className="clearfix" />
			</div>
			<div className="x_content"><AppPriorities /></div>
		</section>

		<section className="x_panel" aria-labelledby="thresholds-title">
			<div className="x_title">
				<h2 id="thresholds-title">Operating thresholds</h2>
				<div className="clearfix" />
			</div>
			<Thresholds />
		</section>

		<section className="x_panel" aria-labelledby="dual-fuel-title">
			<div className="x_title">
				<h2 id="dual-fuel-title">Dual fuel</h2>
				<div className="clearfix" />
			</div>
			<div className="x_content"><DualFuel /></div>
		</section>
	</div>
);

export default RuleEngine;
